import { X } from "lucide-react";
import { useId, type ReactNode } from "react";
import { IconButton } from "./IconButton";
import { useOverlay } from "./useOverlay";

export function Dialog({
  eyebrow,
  title,
  description,
  children,
  actions,
  onClose,
  size = "md",
}: {
  eyebrow?: string;
  title: string;
  description?: string;
  children?: ReactNode;
  actions?: ReactNode;
  onClose: () => void;
  size?: "sm" | "md" | "lg";
}) {
  const titleId = useId();
  const descriptionId = useId();
  const dialogRef = useOverlay<HTMLDivElement>(onClose);

  return (
    <div
      className="dialog-backdrop"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div
        ref={dialogRef}
        className={`dialog dialog--${size}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        aria-describedby={description ? descriptionId : undefined}
        tabIndex={-1}
      >
        <header className="dialog__header">
          <div>
            {eyebrow && <span className="eyebrow">{eyebrow}</span>}
            <h2 id={titleId}>{title}</h2>
            {description && <p id={descriptionId}>{description}</p>}
          </div>
          <IconButton label="Fechar diálogo" onClick={onClose}>
            <X />
          </IconButton>
        </header>
        {children && <div className="dialog__body">{children}</div>}
        {actions && <footer className="dialog__actions">{actions}</footer>}
      </div>
    </div>
  );
}
